// extracted by mini-css-extract-plugin
export var box = "_5l-1";
export var checked = "_5l-2";
export var descriptionSpacer = "_5l-9";
export var disabled = "_5l-3";
export var icon = "_5l-6";
export var input = "_5l-0";
export var labelSpacer = "_5l-8";
export var medium = "_5l-5";
export var small = "_5l-4";
export var text = "_5l-7";